export default "/images/vendor/flag-icons/flags/1x1/dg.svg?77d941f801da4b8e40a31d6e64fc1286";